import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { faEdit, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FormControlSearch, SliderPanel } from "../../../components";
import { InputGroup } from "react-bootstrap";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";
import SpecificationInformationCard from "../ManageSpecificationContainer/SpecificationInformationCard";
import { useDeepEffect } from "../../../abstracts";
import { getSourceAndInvestmentList } from "../../../services";
import { isEmpty } from "lodash";

const InvestmentList = [
  {
    investmentName: "Investment Name1",
  },
  {
    investmentName: "Investment Name2",
  },
  {
    investmentName: "Investment Name3",
  },
];

const SourceList = [
  {
    sourceName: "Pretax",
  },
  {
    sourceName: "Aftertax",
  },
  {
    sourceName: "Employer match source",
  },
];

const tableHeader = [
  {
    label: "Investment Name",
    columnName: "investmentName",
    width: "25%",
  },
  {
    label: "Hierarchy",
    columnName: "heirarchy",
    width: "25%",
  },
];

const Data = [
  {
    name: "$ 1000 Plan",
    description:
      "$ 1000 pro - rate across all participants fixed amount payroll processing fee",
    feeType: "Balance based",
    allocationType: "Fixed Amount",
  },
  {
    name: "$ 1000 Plan",
    description:
      "$ 1000 pro - rate across all participants fixed amount payroll processing fee",
    feeType: "Balance based",
    allocationType: "Fixed Amount",
  },
];

const FeeApplicableToContainer = ({ feeApplicableToResponse }) => {
  const [listSpecification, setListSpecification] = useState(Data);
  const planId =
    feeApplicableToResponse?.planMappings?.length == 1 &&
    feeApplicableToResponse?.planMappings[0]?.planId;

  const [investList, setInvestList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [sliderSource, setSliderSource] = useState(false);
  const [sliderInvestment, setSliderInvestment] = useState(false);
  const [sourceSearch, setSourceSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useDeepEffect(() => {
    getSourceAndInvestmentList(planId).then((response) => {
      if (response?.isSuccessfull) {
        setInvestList(response?.investmentTypes);
        setSourceList(response?.sourceLists);
      }
    });
  }, [planId]);

  const handleSearch = (event) => {
    setSearchInput(event.target.value);
  };

  let investmentMergedList = investList.map((t1) => ({
    ...t1,
    ...feeApplicableToResponse?.investmentHeirarchy?.find(
      (t2) => t2.investmentTypeId === t1.investmentTypeId
    ),
  }));
  let sourceMergedList = sourceList.map((t1) => ({
    ...t1,
    ...feeApplicableToResponse?.sourceHeirarchy?.find(
      (t2) => t2.sourceId === t1.sourceId
    ),
  }));

  let filteredSourceData;
  let filteredInvestmentData;

  filteredSourceData = sourceMergedList?.filter((item) => {
    return (
      item.name.toLowerCase().includes(searchInput.toLowerCase()) ||
      item?.cusip?.toLowerCase().includes(searchInput.toLowerCase())
    );
  });

  filteredInvestmentData = investmentMergedList?.filter((item) => {
    return (
      item.name.toLowerCase().includes(searchInput.toLowerCase()) ||
      item?.cusip?.toLowerCase().includes(searchInput.toLowerCase())
    );
  });

  useDeepEffect(() => {
    setSourceSearch(
      sourceMergedList?.filter((x) => {
        return x?.name?.toLowerCase().includes(sourceMergedList?.toLowerCase());
      })
    );
  }, [sourceSearch]);

  return (
    <div className="fee-summary-conatiner">
      <div className="fee-applicable">
        <div className="fee-applicable-card">
          <span className="fw-500 ft-14 headerDetails">
            Fee applicability
            {feeApplicableToResponse?.applicableTo == 1 ? (
              <p className="fw-600 ft-16 valueDetails">{"All Plans"}</p>
            ) : feeApplicableToResponse?.applicableTo == 2 ? (
              <p className="fw-600 ft-16 valueDetails">{"Specific Plans"}</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">{"Plan Groups"}</p>
            )}
          </span>

          {
            <span className="fw-500 ft-14 headerDetails">
              Plan(s) added
              <p className="fw-600 ft-16 valueDetails">
                {feeApplicableToResponse?.applicableTo == 2
                  ? feeApplicableToResponse?.planMappings?.length
                  : feeApplicableToResponse?.planCount}
              </p>
            </span>
          }
        </div>

        {!isEmpty(feeApplicableToResponse?.excludedEmployeeClassifications) && (
          <>
            <div className="fw-500 ft-14">
              Excluded employee classification(s)
            </div>
            <br></br>
            <div className="investmentCard">
              <p className="fw-500 ft-14 headerDetails">
                Employee Classification added
              </p>
              <p style={{ fontWeight: "600", fontSize: "24px" }}>
                {
                  feeApplicableToResponse?.excludedEmployeeClassifications
                    ?.length
                }
              </p>
            </div>
          </>
        )}

        <hr style={{ borderStyle: "dashed", color: " #000 " }}></hr>

        <div className="fw-600 ft-18">Fee Allocation Method</div>
        {!isEmpty(feeApplicableToResponse?.excludedInvestments) && (
          <>
            <br></br>

            <div className="fw-500 ft-14">Excluded investment(s)</div>
            <br></br>
            <div className="investmentCard">
              <p className="fw-500 ft-14 headerDetails">Investments Added</p>
              <p style={{ fontWeight: "600", fontSize: "24px" }}>
                {feeApplicableToResponse?.excludedInvestments?.length}
              </p>
            </div>
          </>
        )}
        <br></br>

        {/* <br></br> */}

        <div className="fw-500 ft-14 headerDetails">
          Allocation method
          {feeApplicableToResponse?.allocationMethod == 3 ? (
            <div className="fw-600 ft-16 valueDetails">
              {"Source Prorata & Investment Prorata"}
            </div>
          ) : feeApplicableToResponse?.allocationMethod == 1 ? (
            <div className="fw-600 ft-16 valueDetails">
              {"Source Hierarchy"}
            </div>
          ) : (
            <div className="fw-600 ft-16 valueDetails">
              {"Investment Hierarchy"}
            </div>
          )}
        </div>

        <br></br>
        <div className="fw-500 ft-14 headerDetails">
          Deduct fee from
          {feeApplicableToResponse?.deductFeeFrom == 1 ? (
            <div className="fw-600 ft-16 valueDetails">{"Account Balance"}</div>
          ) : feeApplicableToResponse?.allocationMethod == 1 ? (
            <div className="fw-600 ft-16 valueDetails">{"Vested Balance"}</div>
          ) : (
            <div className="fw-600 ft-16 valueDetails">
              {"Investment Hierarchy"}
            </div>
          )}
        </div>

        <br></br>

        {feeApplicableToResponse?.allocationMethod == 2 && (
          <>
            <div className="ft-16 fw-600">Source(s)</div>
            <div className="AllocationBox">
              <p className="fw-600 ft-18">
                {sourceList.length}
                <span className="ml-3 fw-500 ft-16 headerDetails">
                  Source(s)
                </span>
                <>
                  {sourceList?.slice(0, 3)?.map((item) => (
                    <span className="ml-4 fw-600 ft-14 capsule">
                      {item.name}
                    </span>
                  ))}
                </>
                {sourceList.length > 3 && (
                  <span
                    className="fw-500 ft-14 ml-5 cursor-pointer primary-small"
                    style={{ textDecoration: "underLine" }}
                    onClick={() => setSliderSource(true)}
                  >
                    +{sourceList.length - 3} More
                  </span>
                )}
              </p>
            </div>

            <br></br>
            <div className="ft-16 fw-600">Investment(s)</div>
            <span className="fw-500 ft-14 headerDetails">
              {feeApplicableToResponse?.investmentHeirarchy.length} Records
              Found
            </span>

            <div style={{ width: "45%", marginTop: "30px" }}>
              <div
                className="w-100 justify-content-between disp-flex flex-row"
                style={{ padding: "0px 15px" }}
              >
                <div
                  style={{
                    color: "#919191",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "7px",
                  }}
                >
                  {"Investment name"}
                </div>
                <div
                  // className="mr-4"
                  style={{
                    color: "#919191",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "7px",
                  }}
                >
                  Hierarchy
                </div>
              </div>
              {investmentMergedList?.map((data, index) => (
                <div
                  className="w-100 justify-content-between disp-flex flex-row "
                  style={{
                    borderRadius: "8px",
                    padding: "15px 40px 0px 15px",
                    justifyItems: "center",
                    textAlign: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    className="mb-0 ft-14 fw-400"
                    style={{ paddingTop: "5px" }}
                  >
                    {data.name}
                  </div>
                  <div>{data.heirarchyNumber}</div>
                </div>
              ))}
            </div>
          </>
        )}

        {feeApplicableToResponse?.allocationMethod == 1 && (
          <>
            <div className="ft-16 fw-600">Investment(s)</div>
            <div className="AllocationBox">
              <p className="fw-600 ft-18">
                {investList.length}
                <span className="ml-3 fw-500 ft-16 headerDetails">
                  Investment(s)
                </span>
                <>
                  {investList.slice(0, 3)?.map((item) => (
                    <span className="ml-4 fw-600 ft-14 capsule">
                      {item.name}
                    </span>
                  ))}
                </>
                {investList.length > 3 && (
                  <span
                    className="fw-500 ft-14 ml-5 cursor-pointer"
                    style={{ color: "$primary", textDecoration: "underLine" }}
                    onClick={() => setSliderInvestment(true)}
                  >
                    +{investList.length - 3} More
                  </span>
                )}
              </p>
            </div>

            <br></br>
            <div className="ft-16 fw-600">Source(s)</div>
            <span className="fw-500 ft-14 headerDetails">
              {feeApplicableToResponse?.sourceHeirarchy.length} Records Found
            </span>

            <div style={{ width: "45%", marginTop: "30px" }}>
              <div
                className="w-100 justify-content-between disp-flex flex-row"
                style={{ padding: "0px 15px" }}
              >
                <div
                  style={{
                    color: "#919191",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "7px",
                  }}
                >
                  {"Source Name"}
                </div>
                <div
                  // className="mr-4"
                  style={{
                    color: "#919191",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "7px",
                  }}
                >
                  Hierarchy
                </div>
              </div>
              {sourceMergedList?.map((data, index) => (
                <div
                  className="w-100 justify-content-between disp-flex flex-row "
                  style={{
                    borderRadius: "8px",
                    padding: "15px 40px 0px 15px",
                    justifyItems: "center",
                    textAlign: "center",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    className="mb-0 ft-14 fw-400"
                    style={{ paddingTop: "5px" }}
                  >
                    {data.name}
                  </div>
                  {data.heirarchyNumber != null ? (
                    <div>{data.heirarchyNumber}</div>
                  ) : (
                    <div>{"-"}</div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        {feeApplicableToResponse?.allocationMethod == 2 && (
          <SliderPanel
            isOpen={sliderSource}
            size="48"
            showHeader={true}
            showCancel={true}
            onClose={() => {
              setSliderSource(false);
            }}
            backdropClicked={() => setSliderSource(false)}
          >
            <div
              style={{
                marginTop: "-60px",
                fontWeight: "600",
                fontSize: "24px",
              }}
            >
              Source Details
            </div>
            <div
              style={{ fontWeight: "600", fontSize: "14px", color: "#9E9E9E" }}
            >
              {sourceMergedList?.length} Sources
            </div>
            <hr></hr>

            <div
              className="flex-search"
              style={{ marginTop: "-30px", marginLeft: "43px" }}
            >
              <InputGroup>
                <InputGroup.Prepend>
                  <div
                    className="search-icon-postion"
                    style={{ marginLeft: "-35px", marginTop: "37px" }}
                  >
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </div>
                </InputGroup.Prepend>

                <FormControlSearch
                  size="xs"
                  type="search"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{
                    borderRadius: "5px",
                    width: "18rem",
                    marginTop: "27px",
                    marginLeft: "-44px",
                    paddingLeft: "30px",
                  }}
                />
              </InputGroup>
            </div>
            <br></br>

            {filteredSourceData.map((item, index) => {
              return (
                <>
                  <div>{item.name}</div>
                  <hr></hr>
                </>
              );
            })}
          </SliderPanel>
        )}

        {feeApplicableToResponse?.allocationMethod == 1 && (
          <SliderPanel
            isOpen={sliderInvestment}
            size="48"
            showHeader={true}
            showCancel={true}
            onClose={() => {
              setSliderInvestment(false);
            }}
            backdropClicked={() => setSliderInvestment(false)}
          >
            <div
              style={{
                marginTop: "-60px",
                fontWeight: "600",
                fontSize: "24px",
              }}
            >
              Investments Details
            </div>
            <div
              style={{ fontWeight: "600", fontSize: "14px", color: "#9E9E9E" }}
            >
              {investmentMergedList?.length} investments
            </div>
            <hr></hr>

            <div
              className="flex-search"
              style={{ marginTop: "-30px", marginLeft: "43px" }}
            >
              <InputGroup>
                <InputGroup.Prepend>
                  <div
                    className="search-icon-postion"
                    style={{ marginLeft: "-35px", marginTop: "37px" }}
                  >
                    <i class="fas fa-search" aria-hidden="true"></i>
                  </div>
                </InputGroup.Prepend>

                <FormControlSearch
                  size="md"
                  type="search"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{
                    borderRadius: "5px",
                    width: "35rem",
                    marginTop: "27px",
                    marginLeft: "-44px",
                    paddingLeft: "30px",
                  }}
                />
              </InputGroup>
            </div>
            <br></br>

            {filteredInvestmentData.map((item, index) => {
              return (
                <>
                  <div>{item.name}</div>
                  <hr></hr>
                </>
              );
            })}
          </SliderPanel>
        )}
      </div>
    </div>
  );
};

export default FeeApplicableToContainer;
